import {
    GET_POINTS_BY_OIL_DELIVERY, IS_LOADING_POINTS_BY_OIL_DELIVERY, POST_RECORD_DELIVERY, IS_LOADING_POST_REGISTER,
    ERROR_POST_RECORD_DELIVERY, GET_POST_TOTAL_RECEIVED, IS_LOADING_GET_ALL_RECEIVED_OIL, GET_ALL_RECEIVED_OIL,
    IS_LOADING_GET_POST_CONSOLIDATE_OIL_DELIVERING, GET_POST_CONSOLIDATE_OIL_DELIVERING, 
    IS_LOADING_GET_OIL_RECEIVED_BY_ECOIDEAS, GET_OIL_RECEIVED_BY_ECOIDEAS,
    IS_LOADING_GET_POST_HISTORICAL_OIL_DELIVERING, GET_POST_HISTORICAL_OIL_DELIVERING
} from '../actions/types'

const initialState = {
    about: 0,
    ecopoints: 0,
    isLoading: false,
    userEmail: '',
    isLoadingPostRegister: false,
    recordOil: [],
    totalLiters: 0,
    entityId: 0,
    isLoadingGetAllReceivedOil: true,
    allReceivedOil: [],
    hasMoreAllRecivedOil: true,
    skipAllRecivedOil: 0,
    isLoadingGetConsolidateOilDelivering: true,
    totalPointsDelivery: 0,
    totalLitersDelivery: 0,
    isLoadingGetOilReceivedByEcoideas: true,
    oilReceivedByEcoideas: 0,
    isLoadingHistoricalOilDelivery: true,
    historicalDelivery: [],
    hasMoreHistoricalDelivery: true,
    skipHistoricalDelivery: 0,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case IS_LOADING_POINTS_BY_OIL_DELIVERY:
            return { ...state, isLoading: true }

        case GET_POINTS_BY_OIL_DELIVERY:
            return { ...state, about: action.payload.about, ecopoints: action.payload.points, isLoading: false }

        case IS_LOADING_POST_REGISTER:
            return { ...state, isLoadingPostRegister: true }

        case POST_RECORD_DELIVERY:
            const recordOil = Array.from(state.recordOil);
            recordOil.push(action.payload);
            return { ...state, isLoadingPostRegister: false, recordOil }

        case ERROR_POST_RECORD_DELIVERY:
            return { ...state, isLoadingPostRegister: false }

        case GET_POST_TOTAL_RECEIVED:
            return { ...state, totalLiters: action.payload[0].totalLiters }

        case IS_LOADING_GET_ALL_RECEIVED_OIL:
            return { ...state, isLoadingGetAllReceivedOil: true }

        case GET_ALL_RECEIVED_OIL:
            let idsReceivedOil = new Set(state.allReceivedOil.map(receivedOil => receivedOil._id));
            let merge = [
                ...state.allReceivedOil,
                ...action.payload.data.filter(receivedOil => !idsReceivedOil.has(receivedOil._id))
            ];
            return {
                ...state,
                hasMoreAllRecivedOil: action.payload.hasMore,
                skipAllRecivedOil: action.payload.skip,
                allReceivedOil: merge,
                isLoadingGetAllReceivedOil: false
            }

        case IS_LOADING_GET_POST_CONSOLIDATE_OIL_DELIVERING:
            return { ...state, isLoadingGetConsolidateOilDelivering: true }

        case GET_POST_CONSOLIDATE_OIL_DELIVERING:
            return {
                ...state,
                totalLitersDelivery: action.payload.totalLiters,
                totalPointsDelivery: action.payload.totalPointsReceived,
                isLoadingGetConsolidateOilDelivering: false
            }

        case IS_LOADING_GET_OIL_RECEIVED_BY_ECOIDEAS:
            return { ...state, isLoadingGetOilReceivedByEcoideas: true }

        case GET_OIL_RECEIVED_BY_ECOIDEAS:
            return {
                ...state,
                oilReceivedByEcoideas: action.payload,
                isLoadingGetOilReceivedByEcoideas: false
            }

        case IS_LOADING_GET_POST_HISTORICAL_OIL_DELIVERING:
            return { ...state, isLoadingHistoricalOilDelivery: true }

        case GET_POST_HISTORICAL_OIL_DELIVERING:
            let idsHistoricalDelivery = new Set(state.historicalDelivery.map(delivery => delivery._id));
            let mergeHistoricalDelivery = [
                ...state.historicalDelivery,
                ...action.payload.data.filter(delivery => !idsHistoricalDelivery.has(delivery._id))
            ];
            return {
                ...state,
                hasMoreHistoricalDelivery: action.payload.hasMore,
                skipHistoricalDelivery: action.payload.skip,
                historicalDelivery: mergeHistoricalDelivery,
                isLoadingHistoricalOilDelivery: false,
            }

        default:
            return state
    }
}
